<script>
import PaginationButtons from './PaginationButtons.vue'

  export default {
    components: {
      PaginationButtons
    },
    props: {
      pagination: {
        type: Object,
      },      
      disabledPagination: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      showMe() {
        if(this.pagination.total == 0) return 'No hay registros para mostrar'

        const start = (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
        const end = Math.min(start + this.pagination.perPage - 1, this.pagination.total);
        return `Mostrando registros del ${start} al ${end} de un total de ${this.pagination.total} registros`;
      }
    },
    methods: {
      controlarCambioPagination(page) {
        this.$emit('changePage', page)
      }
    },
  }
</script>

<template>
  <div style="display: flex; justify-content: space-between;">
      <p class="results">{{ showMe }}</p>
      <PaginationButtons
        :current-page="pagination.currentPage"
        :total="pagination.total"
        :per-page="pagination.perPage"
        :max-visible-buttons="7"
        :disabled="disabledPagination"
        @change="controlarCambioPagination($event)"
    ></PaginationButtons>
    </div>
</template>